import Vue from 'vue';
import {remove, find, isFunction} from 'lodash';

let getCode = function(js) {
    // Remove export default
    let ed = js.indexOf('export default');
    let curly = js.indexOf('{');
    if (ed != -1 && ed < curly) {
        js = js.substring(ed + 14);
    }

    let f;
    try {
        f = new Function(`return ${js}`);
    }
    catch {
        f = new Function(`return {}`);
    }
    return f();
};

import GroupTraining from './views/GroupTraining.vue';
import Html from './views/Html.vue';
import Text from './views/Text.vue';
import MenuItem from './components/MenuItem.vue';
import Carousel from './views/Carousel.vue';
import Button from './views/Button.vue';
import ExpansionPanel from './views/ExpansionPanel.vue';
import Card from './views/Card.vue';
import ResourceBooking from './views/ResourceBooking.vue';
import ResourceBookingCategory from './views/ResourceBookingCategory.vue';
import ResourceBookingStartPage from './views/ResourceBookingStartPage.vue';
import Shop from './views/Shop.vue';
import ResourceBookingServiceList from './views/ResourceBookingServiceList.vue';
import CourseList from './views/CourseList.vue';
import CourseCategoryList from './views/CourseCategoryList.vue';
import CourseStartPage from './views/CourseStartPage.vue';
import CourseBooking from './views/CourseBooking.vue';
import MyGreeting from './views/MyGreeting.vue';
import MyTrainingCards from './views/MyTrainingCards.vue';
import MyDoors from './views/MyDoors.vue';
import MyPage from './views/MyPage.vue';
import NewsList from './views/NewsList.vue';
import CheckoutButton from './views/CheckoutButton.vue';
import Separator from './views/Separator.vue';
import Empty from './views/Empty.vue';
import Image from './views/Image.vue';
import TextNext from './views/TextNext.vue';
import ContactForm from './views/ContactForm.vue';
import Logout from './views/Logout.vue';
import BottomBarButton from './views/BottomBarButton.vue';
import SiteSelector from './views/SiteSelector.vue';
import StaffList from './views/StaffList.vue';
import CuratorIO from './views/CuratorIO.vue';
import WorkoutTypes from './views/WorkoutTypes.vue';
import GoogleMap from './views/GoogleMap.vue';
import SfRowLayout from './sf/SfRowLayout.vue';
import SfRow from './sf/SfRow.vue';
import SfColumn from './sf/SfColumn.vue';
import SfEmpty from './sf/SfEmpty.vue';
import dyncomp0 from './dyncomp0.vue'
Vue.component("zoezi-bb3d3506a74581dd", dyncomp0);
import dyncomp1 from './dyncomp1.vue'
Vue.component("zoezi-494ff605126ef546", dyncomp1);
import dyncomp2 from './dyncomp2.vue'
Vue.component("zoezi-6307b820ed1efb88", dyncomp2);
let optionalComponents = [GroupTraining, Html, Text, MenuItem, Carousel, Button, ExpansionPanel, Card, ResourceBooking, ResourceBookingCategory, ResourceBookingStartPage, Shop, ResourceBookingServiceList, CourseList, CourseCategoryList, CourseStartPage, CourseBooking, MyGreeting, MyTrainingCards, MyDoors, MyPage, NewsList, CheckoutButton, Separator, Empty, Image, TextNext, ContactForm, Logout, BottomBarButton, SiteSelector, StaffList, CuratorIO, WorkoutTypes, GoogleMap, SfRowLayout, SfRow, SfColumn, SfEmpty];
const registerAdditionalComponents = () => {};


/* Components which can be attached dynamically but not present in config */
import ComponentWrapper from './components/ComponentWrapper.vue';
import ContentsContainer from './components/ContentsContainer.vue'
import AutoImg from './components/AutoImg.vue';
import VueDraggable from 'vuedraggable';
import ErrorDialog from './components/ErrorDialog.vue';
import FormField from './components/FormField.vue';
import MediaLibrary from './components/MediaLibrary.vue';
import TemplateSettings from './views/TemplateSettings.vue';
import Page from './components/Page.vue';
import RowLayout from './views/RowLayout.vue';
import Row from './views/Row.vue';
import Column from './views/Column.vue';
import Login from './views/Login.vue';
import Terms from './views/Terms.vue';
import ResetPassword from './views/ResetPassword.vue';
import Unsubscribe from './views/Unsubscribe.vue';
import MailingUnsubscribe from './views/MailingUnsubscribe.vue';
import CookieBar from './views/CookieBar.vue';
import AccountButton from './views/AccountButton.vue';
import AppBar from './views/AppBar.vue';
import BottomBar from './components/AppBottomBar.vue';
import Root from './components/Root.vue';
import SfRoot from './sf/SfRoot.vue';
import SfPage from './sf/SfPage.vue';
import ExpoSettings from './views/ExpoSettings.vue';
import TeamsportBooking from './views/TeamsportBooking.vue';
import TeamsportEventTypePreview from './views/TeamsportEventTypePreview.vue';
import PopupContainer from './components/PopupContainer.vue';
import CustomFormFields from './components/CustomFormField.vue';
import CustomForm from './components/CustomForm.vue';

let components = [...optionalComponents, Page, RowLayout, Row, Column, Login, Terms, ResetPassword, Unsubscribe, MailingUnsubscribe, CookieBar, AccountButton, AppBar, BottomBar, Root, TeamsportBooking, TeamsportEventTypePreview, SfRoot, SfPage, PopupContainer, CustomFormFields, CustomForm];

// Components available for external partners through the development
// portal. Not accessible from the Flex tool.
Vue.component('ContentsContainer', ContentsContainer);
Vue.component('component-wrapper', ComponentWrapper)
Vue.component('v-auto-img', AutoImg)
import { VBtn } from 'vuetify/lib';
Vue.component('v-btn', VBtn)
Vue.component('v-draggable', VueDraggable)
Vue.component('ErrorDialog', ErrorDialog)
Vue.component('FormField', FormField)
Vue.component('MediaLibrary', MediaLibrary)
Vue.component('zoezi-template-settings', TemplateSettings) // FIXME: Temporary
components.push(TemplateSettings);
Vue.component('zoezi-exposettings', ExpoSettings)
components.push(ExpoSettings)



let getType = function(prop) {
    let type = 'text';
    if (prop.fulltype !== undefined) {
        type = prop.fulltype;
    } else {
        if (prop.type === String) {
            type = 'text';
        } else if (prop.type === Boolean) {
            type = 'checkbox';
        } else if (prop.type == Number) {
            type = 'number';
        }
    }

    return type;
}

export default {
    registerVueComponents(additionalComponents, siteconfig, homepage_type) {
        registerAdditionalComponents(additionalComponents, components, homepage_type);
        this.updateOwnComponents(siteconfig);
        let typeIsCompatible = c => (c?.zoezi?.type || 'mb') == homepage_type;
        components = components.filter(typeIsCompatible)
        components.forEach(c => {
            Vue.component(c.name, c);
        })

        this.setComponentDefaults(siteconfig);
    },
    updateOwnComponents(siteconfig) {
        if (siteconfig.ownComponents) {
            Object.values(siteconfig.ownComponents).forEach(c => {
                try {
                    let component = Object.assign({}, getCode(c.js));
                    component.zoezi = {
                        title: c.name,
                        icon: c.icon,
                        own: true
                    };
                    component.name = c.id;
                    let compilation = Vue.compile(c.html);
                    component.render = compilation.render;
                    component.staticRenderFns = compilation.staticRenderFns;
                    component.css = c.css;
                    
                    let existing = this.getComponent(component.name);
                    if (!existing) {
                        components.push(component)
                    } else {
                        Object.assign(existing, component)
                    }
                    Vue.component(c.id, component)
                }
                catch {
                    // Empty
                }
            })
            this.setComponentDefaults(siteconfig);

            let own = components.filter(c => c.zoezi && c.zoezi.own);
            let toremove = own.filter(c => !siteconfig.ownComponents[c.name]);
            toremove.forEach(t => {
                let i = components.indexOf(t);
                components.splice(i, 1);
            })
        }
    },
    getComponent(componentName) {
        return components.find(x => x.name == componentName);
    },
    getComponentProps(componentName) {
        let result = [];
        let c = this.getComponent(componentName);
        if (!c) {
            return [];
        }
        for (const [prop_name, prop] of Object.entries(c.props || {})) {
            if (!prop.type || prop.type == Function || (prop.type == Array && !prop.fulltype) || (prop.type == Object && !prop.fulltype) || !prop.title) {
                continue;
            }

            let p = {name: prop_name, title: prop.title, type: getType(prop), default: prop.default, typeinfo: prop.typeinfo, global: prop.global, section: prop.section};
            result.push(p);
        }

        return result;
    },
    getAllComponents() {
        return components;
    },
    getComponents() {
        return components.filter(c => c.zoezi && !c.zoezi.internal);
    },
    getAllGlobalSettings() {
        return this.getAllComponents().map(component => {
            let props = this.getComponentProps(component.name).filter(prop => prop.global);
            return {component, props}
        }).filter(x => x.props.length);
    },
    addComponents(arr) {
        remove(arr, p => !!p.component);
        find(arr, x => x.id == 'component').options = components.map(pt => ({id: pt.name, name: pt.title})).sort((a, b) => a.name.localeCompare(b.name));

        components.forEach(component => {
            for (const [prop_name, prop] of Object.entries(component.props || {})) {
                if (prop.type == Function || prop.type == Array) {
                    continue;
                }

                let type = getType(prop);
                
                let visible = function(field, fields) {
                    let c = fields.find(f => f.id == 'component')
                    return field.component == c.value;
                };

                let getKey = function(field) {
                    if (field.component) {
                        return field.component + '.' + field.id;
                    }
                    return field.id;
                };
                
                let f = {id: 'props.' + prop_name, label: prop.title, type: type, visible: visible, component: component.name, initial: prop.default, getKey: getKey};
                arr.push(f);
            }
        });
    },
    addNewComponent(config) {
        this.makeEmptyConfig(config);        
        // For a newly added component - try to find it using its id
        this.selectComponent(config.id);
    },
    makeEmptyConfig(config) {
        config = {id: '0'.repeat(64).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);}), component: 'zoezi-empty', props: {}, ...config};
        this.getComponentProps(config.component).forEach(prop => {
            if (prop.default !== undefined && config.props[prop.name] === undefined && !prop.global) {
                config.props[prop.name] = isFunction(prop.default) ? prop.default() : prop.default;
            }
        });

        let c = this.getComponent(config.component);
        if (c?.zoezi?.getDefaultStyle) {
            config.style = Object.assign({}, c.zoezi.getDefaultStyle());
        }

        return config;
    },
    selectComponent(id) {
        Vue.nextTick(() => {
            let elm = document.getElementById(id);

            let doSelect = function(x) {
                if (!x) {
                    return;
                }

                if (x.__vue__ && x.__vue__.select) {
                    x.__vue__.select();
                } else {
                    doSelect(x.parentElement);
                }
            }

            doSelect(elm);
        })
    },
    setComponentDefaults(siteconfig) {
        let getGlobalSetting = function(componentName, propName) {
            return siteconfig.componentDefaults?.[componentName]?.[propName];
        };

        this.getAllGlobalSettings().forEach(c => {
            c.props.forEach(prop => {
                if (c.component.props[prop.name] !== undefined) {
                    let value = getGlobalSetting(c.component.name, prop.name);
                    if (value !== undefined) {
                        c.component.props[prop.name].default = value;
                    }
                }
            })
        })
    },
    getLiveComponents(componentName) {
        let firstWrapper;
        let getAll = (node, items) => {
            if (!node) {
                return;
            }
            if (!firstWrapper && node.$options.name == 'ComponentWrapper') {
                this.firstWrapper = node;
            }

            node.$children.forEach((x) => getAll(x, items))

            if (node.$options.name == componentName) {
                items.push(node);
            }
        };

        let items = [];
        getAll(window.$vue, items);
        return items;
    },
    updateAllLiveComponents(componentName) {
        let components = this.getLiveComponents(componentName);
        components.forEach(c => {
            while (c && c.$options.name != 'ComponentWrapper') {
                c = c.$parent;
            }

            if (c && c.update) {
                c.update();
            }
        });
    },
    getCompiler() {
        return compiler;
    }
}
